<template>
  <div :class="[$style.guideRemind, fullScreen && $style.fullScreen]">
    <img :src="`${$cdnLink}/charge/close.png`" alt="" :class="$style.close" @click="$emit('close')" />
    <p v-html="guideRemindInfo.pop_text"></p>
    <div :class="$style.btnGroup">
      <button @click="redirectWechat" v-if="guideRemindInfo.pop_jump == 1">跳转公众号</button>
      <button :class="`copy-btn`" @click="copyType = 0" :data-clipboard-text="guideRemindInfo.pop_value" v-else>复制公众号</button>
      <button :class="`copy-btn`" @click="copyType = 1" id="username" :data-clipboard-text="userName">复制账号</button>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { mapState } from 'vuex';
import { gameOpenDownloads } from '@/bridge/AppJsBridge';
import isFullScreen from '@/libs/business/fullScreen';

export default {
  name: '',
  data() {
    return {
      userName: '',
      fullScreen: '',
      copyType: 0
    };
  },
  created() {
    this.fullScreen = isFullScreen() || this.isSuspend;
  },
  mounted() {
    const userName = this.$getStorage('username');
    this.userName = userName;
    this.copyInit();
  },
  computed: {
    ...mapState({
      guideRemindInfo: (state) => state.pay.guideRemindInfo,
    }),
  },
  methods: {
    redirectWechat() {
      gameOpenDownloads({
        gameUrl: this.guideRemindInfo.pop_value,
      });
    },
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', (e) => {
        console.log(this.copyType)
        this.$toast(this.copyType ? '账号复制成功' : '公众号复制成功，可前往微信进行粘贴');
      });
    },
  },
};
</script>

<style lang="scss" module>
.guideRemind {
  width: 100%;
  height: 100%;
  background: url('#{$cdn-url}/charge/bg.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  padding: 1.2rem 0.9rem 0;
  .close {
    position: absolute;
    top: 0.15rem;
    right: 0.15rem;
    width: 0.4rem;
    height: 0.4rem;
  }
  p {
    margin-bottom: 0.2rem;
    height: 2.8rem;
    overflow-y: auto;
    font-size: 0.32rem;
    line-height: 0.46rem;
    text-align: left;
  }
  .btnGroup {
    display: flex;
    justify-content: space-between;
    margin: auto;
    > button {
      width: 2.7rem;
      height: 0.8rem;
      color: #ffffff;
      background: #ff452e;
      border-radius: 0.8rem;
      font-size: 0.3rem;
      border: none;
      outline: none;
    }
  }
  &.fullScreen {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 342px;
    height: 280px;
    margin: auto;
    padding-top: 60px 45px 0;
    .close {
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
    }
    p {
      // background: #000000;
      margin-bottom: 10px;
      height: 140px;
      font-size: 16px;
      line-height: 23px;
    }
    .btnGroup {
      > button {
        width: 115px;
        height: 40px;
        border-radius:40px;
        font-size: 15px;
      }
    }
  }
}
</style>
